exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.drag-main-block[data-v-53a2e2c6] {\n  margin: 10px 0 10px;\n}\n.drag-block .top[data-v-53a2e2c6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  grid-gap: 15px;\n}\n.prescription-text[data-v-53a2e2c6] {\n  white-space: pre-line;\n}\np[data-v-53a2e2c6] {\n    margin-top: 0;\n   margin-bottom: 0 !important;\n}\n", ""]);

// exports
